var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-app flex-row align-items-center",class:{ 'c-dark-theme': _vm.$store.state.darkMode }},[_c('CContainer',[_c('CRow',{staticClass:"justify-content-center"},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }